import script from "./card.vue?vue&type=script&setup=true&lang=js"
export * from "./card.vue?vue&type=script&setup=true&lang=js"

import "./card.vue?vue&type=style&index=0&id=3ccbf7fa&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccbf7fa"]])

export default __exports__